import React from "react";
import Modal from "../UIElements/Modal";
import { Icon } from "../UIElements/Icon";
import { useTranslation } from "react-i18next";

const FranchiseChangeConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  currentFranchiseName,
  newFranchiseName,
  isLoading = false,
}) => {
  const { t } = useTranslation("aiAgents");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("franchiseChange.title")}
      subtitle={
        <>
          {t("franchiseChange.subtitle.prefix")}{" "}
          <span className="italic">{t("franchiseChange.subtitle.field")}</span>{" "}
          {t("franchiseChange.subtitle.suffix")}
        </>
      }
      maxWidth="max-w-2xl"
    >
      <div className="space-y-4">
        {/* Franchise Change Summary */}
        <div className="rounded-lg border border-gray-700 bg-gray-800 p-4">
          <div className="flex items-center justify-between text-sm">
            <div>
              <span className="text-gray-400">
                {t("franchiseChange.summary.current")}
              </span>
              <span className="ml-2 font-medium text-white">
                {currentFranchiseName}
              </span>
            </div>
            <Icon name="ArrowRight" className="mx-2 h-4 w-4 text-gray-500" />
            <div>
              <span className="text-gray-400">
                {t("franchiseChange.summary.new")}
              </span>
              <span className="ml-2 font-medium text-white">
                {newFranchiseName}
              </span>
            </div>
          </div>
        </div>

        {/* Warning Box */}
        <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-4">
          <div className="flex gap-3">
            <Icon
              name="AlertTriangle"
              className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-500"
            />
            <div className="flex-1">
              <h4 className="mb-2 font-medium text-amber-500">
                {t("franchiseChange.warning.title")}
              </h4>
              <ul className="space-y-2 text-sm text-amber-200/80">
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 text-amber-500">•</span>
                  <span>{t("franchiseChange.warning.items.activeReset")}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 text-amber-500">•</span>
                  <span>
                    {t("franchiseChange.warning.items.closedUnaffected")}
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 text-amber-500">•</span>
                  <span>{t("franchiseChange.warning.items.stateLoss")}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3 pt-2">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="text-card-foreground bg-card border-border hover:bg-accent flex-1 rounded-lg border px-4 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          >
            {t("actions.cancel")}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 rounded-lg bg-amber-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-amber-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading
              ? t("actions.saving")
              : t("franchiseChange.actions.confirm")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FranchiseChangeConfirmationModal;
